<template>
    <div class="table-layout">
        <swb-query-sort-area ref="query_model" :config="queryConfig" :queryKey="queryKey" :queryOnLoad="false" :queryHandler="queryHandler"></swb-query-sort-area>

        <el-table :data="staffList" border style="width: 100%" @current-change="handleCurrentChange">
            <el-table-column width="40">
                <template slot-scope="rows">
                    <div class="copy-radio" :class="{'circle' : staffInfo!= null && staffInfo.id == rows.row.id}">
                        <div class="circle-dot"></div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column align="left" prop="comName" label="公司名称"></el-table-column>
            <el-table-column align="left" prop="name" label="员工名称" width="120">
                <template slot-scope="rows">
                    <span>{{rows.row.name}}</span>
                    <span class="font-red">{{rows.row.disabled ? '【禁】' : ''}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="已订阅" width="60">
                <template slot-scope="rows">
                    <span class="font-green" v-if="rows.row.isSubscr">是</span>
                    <span class="font-red" v-else>否</span>
                </template>
            </el-table-column>
            <el-table-column align="center" width="100" prop="phoneNo" label="用户手机"></el-table-column>
            <el-table-column align="center" width="170" prop="idCertNo" label="身份证号"></el-table-column>
            <el-table-column align="center" width="100" prop="contactTel" label="联系电话"></el-table-column>
        </el-table>
        <div class="pagination-layout mt10">
            <el-pagination background class="pagination-layout mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    //
    import retailerApi from '../../api/retailer'
    //
    let mockConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "valueType": "String",
                "label": "公司名称",
                "code": "comName",
                "dataLabel": "text",
                "dataValue": "code",
                "basic": true
            },
            {
                "type": "Text",
                "valueType": "String",
                "label": "员工名称",
                "code": "name",
                "dataLabel": "text",
                "dataValue": "code",
                "basic": true
            },
        ],
        "sortFields": []
    };
    export default {
        name: 'swb-com-staff-for-select',
        desc: '当前公司及下级公司的员工列表 - 选择',
        props: ['eventMsgId'],
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                staffList: [],
                staffInfo: {},
                //
                queryConfig: mockConfigData,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            //
            this.getStaffList();
        },
        methods: {
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.getStaffList();
            },
            handleCurrentChange: function (val) {
                this.staffInfo = val;
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getStaffList();
            },
            getStaffList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.eventMsgId = this.eventMsgId;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                retailerApi.getRetailerStaffListForBizMsg(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        self.staffList = result.data.rows || [];
                        self.totalCount = result.data.pagination.totalCount;
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                let result = {};
                result.type = 'info';
                if(!Utils.isNoB(this.staffInfo.id)) {
                    result.data = this.staffInfo;
                } else {
                    result.type = 'warn';
                    result.message = '请至少选择一个员工';
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/orgStruct/ComStaffForSelect.vue